import blockListSlice from './blockList.slice';
import dashboardSlice from './dashboard.slice';
import settingsSlice from './settings.slice';
import toastSlice from './toast.slice';
import visitorAnalyticsSlice from './visitorAnalytics.slice';
import banner from './banner.slice';
import dataSetting from './dataSettings.slice';
export default { blockListSlice, dashboardSlice, settingsSlice, toastSlice, visitorAnalyticsSlice, banner, dataSetting };
